// extracted by mini-css-extract-plugin
export default {"starterScreen":"pi","starterImage":"qi","already":"ri","starterImageMobile":"si","controlX":"ti","starterTextContain":"ui","starterHeader":"vi","starterBtn":"wi","starterSecondaryBtn":"xi","starterBanner":"yi","mobileBtnContainer":"zi"};
    if(module.hot) {
      // 1713361640028
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  